export var SUPPORT_EMAIL = 'support@gofisherman.com';
export var FISHERMAN_BRAND_IDENTITY = 'FISH';
export var GLAMMATIC_BRAND_IDENTITY = 'GLAM';